import React from 'react';

export type OptionType = {
  label: string;
  value?: string | number;
};

export default function Option(props: OptionType & { selectedValue?: string | number }) {
  return (
    <option aria-selected={props.value === props.selectedValue} value={props.value}>
      {props.label}
    </option>
  );
}
